// src/locales/en/returnNote.js
export const returnNote = {
  // Page titles
  returnNotes: 'Return Notes',
  allReturnNotes: 'All Return Notes',
  createReturnNote: 'Create Return Note',
  returnNoteDetails: 'Return Note Details',
  viewAndManageAllReturnNotes: 'View and manage all return notes',
  processReturn: 'Process Return',
  processReturnDescription: 'Process returned items from an offline sales order',
  confirmReturn: 'Confirm Return',
  listUnavailableTitle: 'Return Notes Unavailable',
  listUnavailableDescription: 'Something went wrong while loading return notes. Please try again.',

  // List columns
  returnNoteNumber: 'Return Note #',
  originalOrder: 'Original Order',
  customer: 'Customer',
  reason: 'Reason',
  refundMethod: 'Refund Method',
  refundAmount: 'Refund Amount',
  createdBy: 'Created By',
  createdAt: 'Created At',
  status: 'Status',
  actions: 'Actions',
  cashier: 'Cashier',
  details: 'Return Details',
  item: 'Item',
  itemsToReturn: 'Items to Return',
  returnedItems: 'Returned Items',
  returnQty: 'Return Quantity',
  refundSummary: 'Refund Summary',
  totalRefundAmount: 'Total Refund Amount',
  loyaltyPointsDeducted: 'Loyalty Points Deducted',

  // Status labels — used via t(`returnNote.status_${note.status}`)
  status_completed: 'Completed',
  status_voided:    'Voided',

  // Refund method labels — used via t(`returnNote.refundMethod_${note.refundMethod}`)
  refundMethod_cash:         'Cash',
  refundMethod_credit_note:  'Credit Note',
  refundMethod_loyalty_points: 'Loyalty Points',

  // Form fields
  selectOriginalOrder: 'Select Original Order',
  lookupOrder: 'Look Up Order',
  orderIdPlaceholder: 'Enter order ID or order number',
  lookupButton: 'Look Up',
  searchOrder: 'Search by order number or ID...',
  noOrdersFound: 'No orders found',
  orderNotFound: 'Order not found',
  notYetDelivered: 'Not yet delivered',
  atLeastOneItemRequired: 'Please select at least one item',
  reasonPlaceholder: 'Enter reason for return...',
  items: 'Items to Return',
  quantityReturned: 'Quantity Returned',
  available: 'Available',
  unitPrice: 'Unit Price',
  lineRefund: 'Line Refund',
  totalRefund: 'Total Refund',
  notes: 'Notes',
  notesPlaceholder: 'Add any notes about this return...',

  // Actions
  create: 'Create Return Note',
  save: 'Save',
  void: 'Void',
  voidReturnNote: 'Void Return Note',
  creditNote: 'Credit Note',
  creditNoteRemaining: 'Remaining Balance',
  linkedCreditNotes: 'Linked Credit Notes',
  print: 'Print',
  printReturnNote: 'Print Return Note',
  backToReturnNotes: 'Back to Return Notes',

  // Confirmations
  confirmVoid: 'Are you sure you want to void this return note? This action cannot be undone.',
  voidReason: 'Reason for Voiding',
  voidReasonPlaceholder: 'Enter reason for voiding...',
  confirmVoidReturnNote: 'Void this return note? Returned stock will be removed again, the order balance and status will be recalculated, and any credit note from this return will be cancelled. Cash refunds already given must be recovered manually.',

  // Filters
  filterByStatus: 'Filter by Status',
  filterByRefundMethod: 'Filter by Refund Method',
  dateFrom: 'From',
  dateTo: 'To',
  searchReturnNotes: 'Search by return note #, order #, customer...',
  allStatuses: 'All Statuses',
  allRefundMethods: 'All Refund Methods',

  // Success / error messages
  returnNoteCreatedSuccessfully: 'Return note created successfully',
  returnNoteVoidedSuccessfully: 'Return note voided successfully',
  failedToCreateReturnNote: 'Failed to create return note',
  failedToVoidReturnNote: 'Failed to void return note',
  failedToLoadReturnNotes: 'Failed to load return notes',
  failedToLoadReturnNoteDetails: 'Failed to load return note details',
  failedToLoadReturnNote: 'Failed to load return note',
  returnCreatedSuccess: 'Return note {number} created successfully',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',

  // Validation
  originalOrderRequired: 'Please select the original order',
  itemsRequired: 'Please select at least one item to return',
  reasonRequired: 'Reason for return is required',
  quantityExceedsAvailable: 'Return quantity cannot exceed the available quantity',

  // Empty states
  noReturnNotesFound: 'No return notes found',
  noReturnNotesYet: 'No return notes yet.',
  noReturnNotesMatchFilters: 'No return notes match your current filters',
  noReturnNotesYetDescription: 'Process your first return to begin tracking returned items.',
  processFirstReturn: 'Process First Return',

  na: 'N/A',
};
